import type { SessionResponse } from '@schemas/session'
import { WorkspaceRoleEnum } from '@schemas/workspace'
import { AccountSwitcher } from './account-switcher.tsx'

export interface ShellHeaderProps {
  session: SessionResponse
}

// RAL-121 board E: the control for switching moved to the account menu, but the readout stays
// where it can't be missed — the workspace you are in, what you are allowed to do there, and the
// account every count on the page is scoped to (rule 11). The account picker is a readout at one
// account and a control at two or more, for members and admins alike.
export function ShellHeader({ session }: ShellHeaderProps) {
  const { activeWorkspace } = session
  if (!activeWorkspace.name) return null
  const readOnly = activeWorkspace.role === WorkspaceRoleEnum.enum.member
  return (
    <header className="-mt-2 mb-6 flex flex-wrap items-center gap-x-3 gap-y-2 border-b border-border-hairline pb-3">
      <span className="font-display text-[15px] font-bold uppercase tracking-tight text-ink-primary">
        {activeWorkspace.name}
      </span>
      {readOnly ? (
        <>
          <span aria-hidden className="h-4 w-px bg-border-hairline" />
          <span className="font-mono text-[11px] text-ink-meta">Analytics only</span>
        </>
      ) : null}
      {session.connected ? (
        <div className="ml-auto flex min-w-0 items-center gap-2">
          <span aria-hidden className="size-1.5 shrink-0 bg-signal-ok" />
          {session.accounts.length > 1 ? (
            <AccountSwitcher session={session} />
          ) : (
            <span className="truncate font-mono text-[11px] text-ink-soft">
              {session.displayName ?? 'Channel linked'}
            </span>
          )}
        </div>
      ) : null}
    </header>
  )
}
